(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grind-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SCOPE = '#gbb-reviews';
    var GREV_WALMART_IDS = {"9f533ae6-83f7-44fb-81b2-58c124b49e80":1,"191e06c4-344b-4cfb-b2cf-607cc403ec71":1,"ab899027-f958-439d-b2d8-ca1d8fef8323":1,"9cd4b16c-3e11-41f5-b03d-b9b84a2f41ce":1,"6c1679a8-a6b2-4232-88c2-f6ad9fbf9255":1,"8e8c3752-d7b6-4e5f-8c7a-0e65a26436c2":1,"f93c02d1-323a-4956-bb5b-cafc2a49f882":1,"8c2d9bee-bb70-4910-9bb6-894343d5a0e1":1,"98afcbcd-b45d-43f2-b939-a95680047762":1,"74265d50-2b62-4255-b19d-2d9427238a76":1,"ebacb0f7-20ce-4a6b-b7f7-8aefbfc35b2b":1,"d2aa7c7d-86e1-49d7-a0eb-4e77432a5228":1,"857faa19-4673-4da4-8237-325e8d85ac00":1,"0c1810de-d9f6-462f-a3d3-d8bfc5de0f77":1,"5aab283d-5ea2-457c-b587-fe66f2d546d9":1,"3ff61a91-7cba-4024-9450-8607c4d6eb87":1,"fc8d9679-2194-4f5a-9342-6fd800668b91":1,"2bc1dd6b-1fbe-4b9f-8263-7e39b920498e":1,"72bc056b-9d81-4678-ab39-43d37d46b5cd":1,"e1c5ded6-bbc4-46cb-8d7b-d71155c126d2":1,"e7d93abf-5852-4016-9138-807e0ccb5171":1,"46d66176-575c-49cb-a28b-264f5cd482cf":1,"1aaf619e-ebc4-474f-8d3f-80b05aa97a77":1,"d995765c-336a-439d-8b6c-01e079f24356":1,"f88e66e9-f548-45c4-bb78-ad44b9eb021f":1,"ef64c6cf-a9e6-4416-8b95-ddbd351cd935":1,"796f75ea-9a92-4f2b-a362-fed8d5513c6a":1,"df1d84c1-9398-4853-98ef-a9955905faed":1,"1540451b-ffe6-4cb6-a059-ee61cf2a845f":1,"ae8fb52d-cd01-4ec5-863d-164003537676":1,"8270733f-c0fc-4e59-a30f-663c253e6cb7":1,"8a913db7-e1aa-4154-9eac-cf94939e639d":1,"588a57c0-1b62-4936-94e2-07ebf4eb916a":1,"6809f14d-bdf4-4458-ba49-e10f48f1e3e4":1,"3756fd2a-be92-4634-ad36-fd7eebf225e7":1,"0d15a833-8fb2-44e7-b5e5-de026201951f":1,"68b528b1-638f-4ee7-a737-d9a3fbce7e52":1,"e954d6e5-0c86-446a-bc53-650d5c6c58c2":1,"619d6ca1-7da1-4585-8635-70f20e8284a1":1,"3912c3d5-8b93-4b4c-84fd-35a423e14f99":1,"9ab93390-aa4c-471f-9322-3c7ff15d2143":1,"76cafd7a-8455-4f0b-af1d-6b8989ddb9ed":1,"542ee376-3b0f-49b6-802c-7b5bde5f290b":1,"db0cf32c-722a-4b38-a561-1b4ea7bc0be1":1,"f11b3d05-a5ad-4b0f-a906-c109a4c3fad4":1,"5d7b17fe-7772-408b-9e2a-a709b52b0a8c":1,"5eed802b-bc8a-43c3-a298-b045fced615b":1,"8a9f6a62-6c94-43a4-b0f3-8d6864201556":1,"50d232fc-9366-45ce-b8e1-37a147f47334":1,"477d27cf-1191-457b-a45f-0ae558a51d3f":1,"ee6072e2-b978-4a11-91cf-c42c85156ad2":1,"3437bbce-c885-40b0-b4c5-13705e0c0772":1,"6892855b-ac04-4e71-895e-6f5cb80f911b":1,"10527629-5721-4faf-b665-46721a224628":1,"b2c17235-27f0-4bc5-a07e-ccd86e5d5b7a":1,"bd3976ba-6490-4eeb-a697-9127c6cca32e":1,"57746df8-5466-4e26-915c-7a090794681a":1,"419a0646-8eb5-4548-b160-4acecc8c6f9b":1,"7657a090-cf52-4c68-877f-6f288ab98990":1,"1d422aa5-0fee-41f7-bd9a-8eb9a3bd61f1":1,"7788d95d-ba9f-4c32-b727-1d7d915cbfb0":1,"b2bd9c46-f553-4137-b92b-d9c7c05e580b":1,"1214e5c6-d153-4f66-b625-9a576cb28d02":1,"581be8a4-b66a-44ee-bc62-83729240369f":1,"14c5fb47-2bba-4fa6-bddb-f35a3d42e86f":1};
    var GREV_PLACEHOLDER = /^(walmart\s?customer|walmart\s?shopper|walmart reviewer|amazon\s?customer|verified buyer|anonymous)$/i;
    function restructure(rev) {
      if (rev.dataset.grevDone) return;
      var icon = rev.querySelector('.jdgm-rev__icon');
      var authorWrap = rev.querySelector('.jdgm-rev__author-wrapper');
      var rating = rev.querySelector('.jdgm-rev__rating');
      var content = rev.querySelector('.jdgm-rev__content');
      var prod = rev.querySelector('.jdgm-rev__prod-info-wrapper');
      if (prod) { prod.innerHTML = prod.innerHTML.replace(/\s*\(out of store\)\s*/gi, ''); }
      var actions = rev.querySelector('.jdgm-rev__actions');
      var ts = rev.querySelector('.jdgm-rev__timestamp');
      var reply = rev.querySelector('.jdgm-rev__reply');
      var name = authorWrap ? authorWrap.innerText.trim() : '';
      if (authorWrap && GREV_PLACEHOLDER.test(name)) { authorWrap.textContent = 'Anonymous'; name = 'Anonymous'; }
      var parts = name.split(/\s+/).filter(Boolean);
      var initials = ((parts[0] ? parts[0][0] : '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase() || 'G';
      if (icon) icon.textContent = initials;
      var verifiedEl = document.createElement('div');
      verifiedEl.className = 'grev-verified';
      verifiedEl.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="#2ca36b"><path d="M9 16.2l-3.5-3.5L4 14.2 9 19.2 20 8.2l-1.4-1.4z"/></svg> Verified buyer';
      if (ts) { ts.classList.remove('jdgm-spinner'); var d = ts.getAttribute('data-content'); if (d) { var dt = new Date(d.replace(' UTC', 'Z').replace(' ', 'T')); if (!isNaN(dt)) ts.textContent = dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } }
      var imported = !!rev.querySelector('.jdgm-rev__transparency-badge[data-badge-type="review_collected_from_another_provider"]');
      var _rid = rev.getAttribute('data-review-id');
      var _vb = rev.getAttribute('data-verified-buyer') === 'true';
      var _srcTxt = GREV_WALMART_IDS[_rid] ? 'Verified review · via Walmart' : (imported ? 'Verified review · via Amazon' : 'Verified review');
      var src = document.createElement('div'); src.className = 'grev-source'; src.textContent = _srcTxt;
      var left = document.createElement('div'); left.className = 'grev-rev-left';
      if (icon) left.appendChild(icon);
      if (authorWrap) left.appendChild(authorWrap);
      if (verifiedEl) left.appendChild(verifiedEl);
      var right = document.createElement('div'); right.className = 'grev-rev-right';
      if (rating) right.appendChild(rating);
      if (content) right.appendChild(content);
      if (prod) right.appendChild(prod);
      if (_srcTxt) right.appendChild(src);
      if (actions) right.appendChild(actions);
      if (reply) right.appendChild(reply);
      if (ts) right.appendChild(ts);
      rev.innerHTML = '';
      rev.appendChild(left); rev.appendChild(right);
      rev.dataset.grevDone = '1';
    }
    function run() {
      var scope = document.querySelector(SCOPE);
      if (!scope) return false;
      var revs = scope.querySelectorAll('.jdgm-rev');
      if (!revs.length) return false;
      Array.prototype.slice.call(revs).forEach(restructure);
      return true;
    }
    function fallbackFetch() {
      var scope = document.querySelector(SCOPE);
      if (!scope) return;
      var w = scope.querySelector('.grev2__widget');
      if (!w || w.getAttribute('data-fallback') !== '1' || w.dataset.grevFb) return;
      if (scope.querySelectorAll('.jdgm-rev').length) return;
      w.dataset.grevFb = '1';
      var u = 'https://cdn.judge.me/reviews/all_reviews_js_based?url=grind-oral-care.myshopify.com&shop_domain=grind-oral-care.myshopify.com&platform=shopify&per_page=6&page=1&review_type=product-reviews&sort_by=most_recent&sort_dir=desc';
      fetch(u).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = d.html;
        var revs = Array.prototype.slice.call(tmp.querySelectorAll('.jdgm-rev')).slice(0, 3);
        if (!revs.length) return;
        var wrap = document.createElement('div'); wrap.className = 'jdgm-rev-widg';
        var list = document.createElement('div'); list.className = 'jdgm-rev-widg__reviews';
        revs.forEach(function (r) { list.appendChild(r); });
        wrap.appendChild(list);
        w.innerHTML = '';
        w.appendChild(wrap);
        run();
      }).catch(function () {});
    }
    var tries = 0;
    var t = setInterval(function () { tries++; if (run() || tries > 50) clearInterval(t); if (tries === 3) fallbackFetch(); }, 300);
    var scope = document.querySelector(SCOPE);
    if (scope && window.MutationObserver) {
      var mo = new MutationObserver(function () { run(); });
      mo.observe(scope, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grind-reviews-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GREV_WALMART_IDS = {"9f533ae6-83f7-44fb-81b2-58c124b49e80":1,"191e06c4-344b-4cfb-b2cf-607cc403ec71":1,"ab899027-f958-439d-b2d8-ca1d8fef8323":1,"9cd4b16c-3e11-41f5-b03d-b9b84a2f41ce":1,"6c1679a8-a6b2-4232-88c2-f6ad9fbf9255":1,"8e8c3752-d7b6-4e5f-8c7a-0e65a26436c2":1,"f93c02d1-323a-4956-bb5b-cafc2a49f882":1,"8c2d9bee-bb70-4910-9bb6-894343d5a0e1":1,"98afcbcd-b45d-43f2-b939-a95680047762":1,"74265d50-2b62-4255-b19d-2d9427238a76":1,"ebacb0f7-20ce-4a6b-b7f7-8aefbfc35b2b":1,"d2aa7c7d-86e1-49d7-a0eb-4e77432a5228":1,"857faa19-4673-4da4-8237-325e8d85ac00":1,"0c1810de-d9f6-462f-a3d3-d8bfc5de0f77":1,"5aab283d-5ea2-457c-b587-fe66f2d546d9":1,"3ff61a91-7cba-4024-9450-8607c4d6eb87":1,"fc8d9679-2194-4f5a-9342-6fd800668b91":1,"2bc1dd6b-1fbe-4b9f-8263-7e39b920498e":1,"72bc056b-9d81-4678-ab39-43d37d46b5cd":1,"e1c5ded6-bbc4-46cb-8d7b-d71155c126d2":1,"e7d93abf-5852-4016-9138-807e0ccb5171":1,"46d66176-575c-49cb-a28b-264f5cd482cf":1,"1aaf619e-ebc4-474f-8d3f-80b05aa97a77":1,"d995765c-336a-439d-8b6c-01e079f24356":1,"f88e66e9-f548-45c4-bb78-ad44b9eb021f":1,"ef64c6cf-a9e6-4416-8b95-ddbd351cd935":1,"796f75ea-9a92-4f2b-a362-fed8d5513c6a":1,"df1d84c1-9398-4853-98ef-a9955905faed":1,"1540451b-ffe6-4cb6-a059-ee61cf2a845f":1,"ae8fb52d-cd01-4ec5-863d-164003537676":1,"8270733f-c0fc-4e59-a30f-663c253e6cb7":1,"8a913db7-e1aa-4154-9eac-cf94939e639d":1,"588a57c0-1b62-4936-94e2-07ebf4eb916a":1,"6809f14d-bdf4-4458-ba49-e10f48f1e3e4":1,"3756fd2a-be92-4634-ad36-fd7eebf225e7":1,"0d15a833-8fb2-44e7-b5e5-de026201951f":1,"68b528b1-638f-4ee7-a737-d9a3fbce7e52":1,"e954d6e5-0c86-446a-bc53-650d5c6c58c2":1,"619d6ca1-7da1-4585-8635-70f20e8284a1":1,"3912c3d5-8b93-4b4c-84fd-35a423e14f99":1,"9ab93390-aa4c-471f-9322-3c7ff15d2143":1,"76cafd7a-8455-4f0b-af1d-6b8989ddb9ed":1,"542ee376-3b0f-49b6-802c-7b5bde5f290b":1,"db0cf32c-722a-4b38-a561-1b4ea7bc0be1":1,"f11b3d05-a5ad-4b0f-a906-c109a4c3fad4":1,"5d7b17fe-7772-408b-9e2a-a709b52b0a8c":1,"5eed802b-bc8a-43c3-a298-b045fced615b":1,"8a9f6a62-6c94-43a4-b0f3-8d6864201556":1,"50d232fc-9366-45ce-b8e1-37a147f47334":1,"477d27cf-1191-457b-a45f-0ae558a51d3f":1,"ee6072e2-b978-4a11-91cf-c42c85156ad2":1,"3437bbce-c885-40b0-b4c5-13705e0c0772":1,"6892855b-ac04-4e71-895e-6f5cb80f911b":1,"10527629-5721-4faf-b665-46721a224628":1,"b2c17235-27f0-4bc5-a07e-ccd86e5d5b7a":1,"bd3976ba-6490-4eeb-a697-9127c6cca32e":1,"57746df8-5466-4e26-915c-7a090794681a":1,"419a0646-8eb5-4548-b160-4acecc8c6f9b":1,"7657a090-cf52-4c68-877f-6f288ab98990":1,"1d422aa5-0fee-41f7-bd9a-8eb9a3bd61f1":1,"7788d95d-ba9f-4c32-b727-1d7d915cbfb0":1,"b2bd9c46-f553-4137-b92b-d9c7c05e580b":1,"1214e5c6-d153-4f66-b625-9a576cb28d02":1,"581be8a4-b66a-44ee-bc62-83729240369f":1,"14c5fb47-2bba-4fa6-bddb-f35a3d42e86f":1};
    var GREV_PLACEHOLDER = /^(walmart\s?customer|walmart\s?shopper|walmart reviewer|amazon\s?customer|verified buyer|anonymous)$/i;
    function restructure(rev) {
      if (rev.dataset.grevDone) return;
      var icon = rev.querySelector('.jdgm-rev__icon');
      var authorWrap = rev.querySelector('.jdgm-rev__author-wrapper');
      var rating = rev.querySelector('.jdgm-rev__rating');
      var content = rev.querySelector('.jdgm-rev__content');
      var prod = rev.querySelector('.jdgm-rev__prod-info-wrapper');
      if (prod) { prod.innerHTML = prod.innerHTML.replace(/\s*\(out of store\)\s*/gi, ''); }
      var actions = rev.querySelector('.jdgm-rev__actions');
      var ts = rev.querySelector('.jdgm-rev__timestamp');
      var reply = rev.querySelector('.jdgm-rev__reply');
      var name = authorWrap ? authorWrap.innerText.trim() : '';
      if (authorWrap && GREV_PLACEHOLDER.test(name)) { authorWrap.textContent = 'Anonymous'; name = 'Anonymous'; }
      var parts = name.split(/\s+/).filter(Boolean);
      var initials = ((parts[0] ? parts[0][0] : '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase() || 'G';
      if (icon) icon.textContent = initials;
      var verifiedEl = document.createElement('div');
      verifiedEl.className = 'grev-verified';
      verifiedEl.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="#2ca36b"><path d="M9 16.2l-3.5-3.5L4 14.2 9 19.2 20 8.2l-1.4-1.4z"/></svg> Verified buyer';
      if (ts) { ts.classList.remove('jdgm-spinner'); var d = ts.getAttribute('data-content'); if (d) { var dt = new Date(d.replace(' UTC', 'Z').replace(' ', 'T')); if (!isNaN(dt)) ts.textContent = dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } }
      var imported = !!rev.querySelector('.jdgm-rev__transparency-badge[data-badge-type="review_collected_from_another_provider"]');
      var _rid = rev.getAttribute('data-review-id');
      var _vb = rev.getAttribute('data-verified-buyer') === 'true';
      var _srcTxt = GREV_WALMART_IDS[_rid] ? 'Verified review · via Walmart' : (imported ? 'Verified review · via Amazon' : 'Verified review');
      var src = document.createElement('div'); src.className = 'grev-source'; src.textContent = _srcTxt;
      var left = document.createElement('div'); left.className = 'grev-rev-left';
      if (icon) left.appendChild(icon);
      if (authorWrap) left.appendChild(authorWrap);
      if (verifiedEl) left.appendChild(verifiedEl);
      var right = document.createElement('div'); right.className = 'grev-rev-right';
      if (rating) right.appendChild(rating);
      if (content) right.appendChild(content);
      if (prod) right.appendChild(prod);
      if (_srcTxt) right.appendChild(src);
      if (actions) right.appendChild(actions);
      if (reply) right.appendChild(reply);
      if (ts) right.appendChild(ts);
      rev.innerHTML = '';
      rev.appendChild(left); rev.appendChild(right);
      rev.dataset.grevDone = '1';
    }
    var JM_URL = 'https://cdn.judge.me/reviews/all_reviews_js_based?url=grind-oral-care.myshopify.com&shop_domain=grind-oral-care.myshopify.com&platform=shopify&review_type=product-reviews&sort_by=most_recent&sort_dir=desc&per_page=25&page=';
    function fetchAllReviews(cb) {
      try {
        var c = JSON.parse(sessionStorage.getItem('grevAll') || 'null');
        if (c && Date.now() - c.t < 600000 && c.html) { cb(c.html); return; }
      } catch (e) {}
      var htmls = [];
      function finish() {
        var all = htmls.join('');
        if (all) { try { sessionStorage.setItem('grevAll', JSON.stringify({ t: Date.now(), html: all })); } catch (e) {} }
        cb(all || null);
      }
      function page(p) {
        if (p > 20) { finish(); return; }
        fetch(JM_URL + p).then(function (r) { return r.json(); }).then(function (d) {
          var h = (d && d.html) || '';
          if (h.indexOf('jdgm-rev') === -1) { finish(); return; }
          htmls.push(h);
          page(p + 1);
        }).catch(finish);
      }
      page(1);
    }
    function updateStats(revs) {
      var n = revs.length, sum = 0, buckets = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      revs.forEach(function (r) {
        var e = r.querySelector('[data-score]');
        var s = e ? parseFloat(e.getAttribute('data-score')) || 0 : 0;
        sum += s;
        var b = Math.round(s);
        if (buckets[b] != null) buckets[b]++;
      });
      if (!n) return;
      var avg = sum / n;
      var heroTxt = document.querySelector('.grev__hero-rating > span:last-child');
      if (heroTxt) heroTxt.innerHTML = '<strong>' + avg.toFixed(1) + '</strong> / 5 · ' + n + ' reviews';
      var big = document.querySelector('.grev__big');
      if (big) big.textContent = avg.toFixed(2);
      var cnt = document.querySelector('.grev__count');
      if (cnt) cnt.textContent = n + ' reviews';
      var hist = document.querySelector('.grev__hist');
      if (hist) {
        var out = '';
        for (var s5 = 5; s5 >= 1; s5--) {
          var c = buckets[s5], pct = Math.round(c * 100 / n);
          out += "<div class='jdgm-histogram__row'><span class='jdgm-histogram__star'>" + s5 + " ★</span><span class='jdgm-histogram__bar'><span class='jdgm-histogram__bar-content' style='display:block;width:" + pct + "%'></span></span><span class='jdgm-histogram__frequency'>" + c + "</span></div>";
        }
        hist.innerHTML = "<div class='jdgm-histogram'>" + out + "</div>";
      }
    }
    function init() {
      // Build the live, current breakdown from the product widget (auto-updates with new reviews)
      var wsrc = document.querySelector('.grev__wsrc');
      var histTarget = document.querySelector('.grev__hist');
      if (wsrc && histTarget) {
        var hist = wsrc.querySelector('.jdgm-histogram');
        if (hist) {
          hist.classList.remove('jdgm-temp-hidden');
          Array.prototype.slice.call(hist.querySelectorAll('.jdgm-histogram__row')).forEach(function (row) {
            var pct = row.getAttribute('data-percentage');
            var fill = row.querySelector('.jdgm-histogram__bar-content');
            if (fill && pct != null) fill.style.width = pct + '%';
          });
          histTarget.innerHTML = '';
          histTarget.appendChild(hist);
        }
        if (wsrc.parentNode) wsrc.parentNode.removeChild(wsrc);
      }

      var widget = document.querySelector('.grev .grind-allrev__widget');
      if (!widget) return;
      Array.prototype.slice.call(widget.querySelectorAll('.jdgm-rev')).forEach(restructure);
      var sortSel = document.querySelector('.grev__sort'), rSel = document.querySelector('.grev__frating'), photos = document.querySelector('.grev__photos'), noRes = document.querySelector('.grev__noresults');
      if (!sortSel) return;
      function rows() { return Array.prototype.slice.call(widget.children).filter(function (n) { return n.classList && n.classList.contains('jdgm-rev'); }); }
      function score(r) { var e = r.querySelector('[data-score]'); return e ? parseFloat(e.getAttribute('data-score')) || 0 : 0; }
      function when(r) { var e = r.querySelector('.jdgm-rev__timestamp'); var d = e && e.getAttribute('data-content'); return d ? (Date.parse(d.replace(' UTC', 'Z').replace(' ', 'T')) || 0) : 0; }
      function hasPhoto(r) { return !!r.querySelector('.jdgm-rev__pics img, img.jdgm-rev__pic-img, .jdgm-rev__pic-img'); }
      function apply() {
        var rs = rows(); var sv = sortSel.value;
        rs.sort(function (a, b) { if (sv === 'high') return score(b) - score(a); if (sv === 'low') return score(a) - score(b); if (sv === 'oldest') return when(a) - when(b); return when(b) - when(a); });
        rs.forEach(function (r) { widget.appendChild(r); });
        var rf = rSel.value, ph = photos.checked, shown = 0;
        rs.forEach(function (r) { var ok = true; if (rf !== 'all' && Math.round(score(r)) !== parseInt(rf, 10)) ok = false; if (ph && !hasPhoto(r)) ok = false; r.style.display = ok ? '' : 'none'; if (ok) shown++; });
        if (noRes) noRes.hidden = shown !== 0;
      }
      sortSel.addEventListener('change', apply); rSel.addEventListener('change', apply); photos.addEventListener('change', apply);
      apply();
      // Upgrade to the full live review set from Judge.me (metafield chunk caps at 25)
      fetchAllReviews(function (html) {
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fetched = Array.prototype.slice.call(tmp.querySelectorAll('.jdgm-rev'));
        var seen = {}, unique = [];
        fetched.forEach(function (r) {
          var id = r.getAttribute('data-review-id') || ('x' + unique.length);
          if (!seen[id]) { seen[id] = 1; unique.push(r); }
        });
        if (unique.length <= rows().length) { updateStats(rows()); return; }
        rows().forEach(function (r) { widget.removeChild(r); });
        unique.forEach(function (r) { widget.appendChild(r); restructure(r); });
        updateStats(unique);
        apply();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 700); });
    else setTimeout(init, 700);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
